import { render, staticRenderFns } from "./SettingsHidden.vue?vue&type=template&id=60d69476&"
import script from "./SettingsHidden.vue?vue&type=script&lang=js&"
export * from "./SettingsHidden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports